import {
  hasSurveyPlan,
  hasSurveyPlusPlan,
  hasSurveyProPlan,
  hasSurveyProPlusPlan,
} from "./entitlements";

/** Advanced trigger sources reserved for Survey Pro+ (site CRM row). */
export const SURVEY_ADVANCED_TRIGGER_SOURCES = ["zendesk", "salesforce"];

/** Basic Pro trigger sources. */
export const SURVEY_BASIC_TRIGGER_SOURCES = ["sonic", "shopify"];

/**
 * Survey capability flags aligned with pivony.com/plans Step 1.
 * Quotas are enforced server-side; these flags drive UI + client save shaping.
 */
export function getSurveyCapabilities(subscriptionRow) {
  const hasSurvey = hasSurveyPlan(subscriptionRow);
  const plus = hasSurveyPlusPlan(subscriptionRow);
  const pro = hasSurveyProPlan(subscriptionRow);
  const proPlus = hasSurveyProPlusPlan(subscriptionRow);

  return {
    hasSurvey,
    /** Plus+: multilingual, logo, color, popup */
    canBrand: plus,
    canMultilingual: plus,
    /** Plus+: allow hiding Pivony watermark (showBranding=false) */
    canRemoveWatermark: plus,
    /** Pro+: voice feedback widgets (Pro and Pro+) */
    canVoice: pro,
    /** Video remains waitlist; surface Pro+ messaging */
    canVideo: false,
    videoWaitlist: true,
    /** Pro+: enable triggered_send channel */
    canTriggeredSend: pro,
    /** Pro+: zendesk/salesforce sources */
    canAdvancedTriggers: proPlus,
    allowedTriggerSources: proPlus
      ? [...SURVEY_BASIC_TRIGGER_SOURCES, ...SURVEY_ADVANCED_TRIGGER_SOURCES]
      : pro
        ? [...SURVEY_BASIC_TRIGGER_SOURCES]
        : [],
  };
}

export default getSurveyCapabilities;
